<div class="e-keyword-filter-bar-container" role="search">
    <div class="e-keyword-filter-bar" [class.e-disabled]="isDisabled">
        <input
            class="e-keyword-filter-field"
            type="text"
            [placeholder]="isDisabled ? ' ' : 'Type to start searching...'"
            autocomplete="off"
            (keyup)="filterByKeyword()"
            aria-label="Enter a keyword to filter the available options."
            [(ngModel)]="keyword"
            [attr.aria-disabled]="isDisabled"
            [disabled]="isDisabled" />
        <i class="far fa-search"></i>
        <button class="e-clear-button" (click)="resetSearch()" aria-label="Clear keywords"><i class="far fa-times"></i></button>
    </div>
</div>
